import uuid from 'react-uuid'

const guid = () => {
  return uuid()
}

export const securityHelper = {
  guid
}
